export const apiErrorMessages = {
    // Errores generales
    DEFAULT: 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente mas tarde.',
    NETWORK_ERROR: 'No se pudo conectar con el servidor. Verifica tu conexión a internet.',
    TIMEOUT: 'La solicitud ha tomado demasiado tiempo. Por favor, intenta nuevamente.',

    // Errores de autenticación
    UNAUTHORIZED: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    FORBIDDEN: 'No tienes permisos para realizar esta acción.',

    // Errores específicos por código de estado
    '400': 'La solicitud no es válida.',
    '401': 'No estás autorizado para realizar esta acción.',
    '403': 'No tienes permisos para acceder a este recurso.',
    '404': 'El recurso solicitado no existe.',
    '409': 'Ya existe un registro con estos datos.',
    '422': 'Los datos proporcionados no son válidos.',
    '429': 'Has realizado demasiadas solicitudes. Por favor, espera un momento.',
    '500': 'Ha ocurrido un error en el servidor. Por favor, intenta más tarde.',
    '502': 'El servidor no está respondiendo correctamente.',
    '503': 'El servicio no está disponible en este momento.',
    '504': 'El servidor ha tardado demasiado en responder.',

    // Errores específicos de negocio
    BUSINESS: {
        INSUFFICIENT_FUNDS: 'No hay fondos suficientes para realizar esta operación.',
        INVALID_ACCOUNT: 'La cuenta especificada no es válida.',
        TRANSACTION_FAILED: 'La transacción no pudo ser completada.',
        DUPLICATE_RECORD: 'Ya existe un registro con estos datos.',
        INVALID_STATUS: 'El estado actual no permite realizar esta acción.',
    }
};

export const getApiErrorMessage = (error) => {
    if (!error) return apiErrorMessages.DEFAULT;

    if (error.message === 'Network Error') {
        return apiErrorMessages.NETWORK_ERROR;
    }

    if (error.code === 'ECONNABORTED') {
        return apiErrorMessages.TIMEOUT;
    }

    if (error.response) {
        const statusCode = error.response.status;
        const errorData = error.response.data;

        if (errorData?.message) {
            return errorData.message;
        }

        return apiErrorMessages[statusCode] || apiErrorMessages.DEFAULT;
    }

    return apiErrorMessages.DEFAULT;
};

// Función para obtener título y mensaje de error contextualizado
export const getContextualErrorMessage = (error, context = 'default') => {
    const message = getApiErrorMessage(error);
    
    // Títulos específicos por contexto
    const contextTitles = {
        upload: {
            'TypeError': 'Error de conexión',
            'AbortError': 'Tiempo de espera agotado',
            'CORS': 'Error de configuración',
            'process': 'Error en el proceso',
            'default': 'Error en la carga'
        },
        default: {
            'default': 'Error'
        }
    };
    
    // Determinar el título basado en el contexto y tipo de error
    const getTitle = () => {
        const titles = contextTitles[context] || contextTitles.default;
        
        if (context === 'upload') {
            if (error.name === 'TypeError' && error.message?.includes('Failed to fetch')) {
                return titles.TypeError;
            }
            if (error.name === 'AbortError' || error.message?.includes('timeout')) {
                return titles.AbortError;
            }
            if (error.message?.includes('CORS')) {
                return titles.CORS;
            }
            if (error.message && (
                error.message.includes('El archivo no cumple con los requisitos') ||
                error.message.includes('No tienes permisos para realizar esta acción') ||
                error.message.includes('Acceso denegado') ||
                error.message.includes('El archivo es demasiado grande') ||
                error.message.includes('Error interno del servidor') ||
                error.message.includes('No se pudo acceder al almacenamiento') ||
                error.message.includes('Error temporal del servicio de almacenamiento') ||
                error.message.includes('Error al subir el archivo')
            )) {
                return titles.process;
            }
        }
        
        return titles.default;
    };
    
    return {
        title: getTitle(),
        description: message
    };
};